import { Switch as MuiSwitch, SwitchProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { isDarkPagePalette } from '@theme/palettes/getPalette';

type SwitchPropsType = SwitchProps & { variant?: 'primary' | 'secondary' };

export const Switch = ({ variant = 'primary', ...props }: SwitchPropsType) => {
  const theme = useTheme();

  const sizeModifier = props?.size === 'small' ? 0.5 : 0.7;
  // primary.dark is a light slate on dark page palettes that the white thumb fades into; use the accent track
  // with a navy thumb there instead, like a checked checkbox
  const isDarkPage = isDarkPagePalette(theme.palette);

  return (
    <MuiSwitch
      focusVisibleClassName='.Mui-focusVisible'
      disableRipple
      {...props}
      sx={{
        width: 42 * sizeModifier,
        height: 26 * sizeModifier,
        padding: 0,
        '& .MuiSwitch-switchBase': {
          padding: 0,
          margin: `${2 * sizeModifier}px`,
          transitionDuration: '300ms',
          '&.Mui-checked': {
            transform: `translateX(${16 * sizeModifier}px)`, // 'translateX(16px)',
            color: isDarkPage ? 'primary.main' : 'common.white',
            '& + .MuiSwitch-track': {
              backgroundColor: variant === 'primary' && !isDarkPage ? 'primary.dark' : 'secondary.main',
              opacity: 1,
              border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.5,
            },
          },
          '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: 'secondary.dark',
            border: '6px solid #fff', // TODO borders into theme
          },
          '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600],
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
          },
        },
        '& .MuiSwitch-thumb': {
          boxSizing: 'border-box',
          width: 22 * sizeModifier,
          height: 22 * sizeModifier,
        },
        '& .MuiSwitch-track': {
          borderRadius: (26 / 2) * sizeModifier,
          backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D', // TODO clean up hex codes
          opacity: 1,
          transition: theme.transitions.create(['background-color'], {
            duration: 500,
          }),
        },
      }}
    />
  );
};
